"use client"

import { useEffect, useState } from "react"
import { ChatLauncherLazy } from "./chat-launcher-lazy"
import type { ChatLauncherProps } from "./chat-launcher"
import { hasEllaDePreviewActive } from "@/lib/ella-de-preview"

/**
 * Mounts the Ella chat launcher in the German market ONLY for a visitor who
 * armed the `?ella-de=<ELLA_DE_PREVIEW_TOKEN>` magic link (the
 * `ella-de-preview-active` cookie). Lets staff dogfood DE chat on prod before
 * `feature:chat` is widened
 * to include `de`.
 *
 * The cookie is read post-hydration in an effect — the same SSR-safe pattern
 * the ai-preview consumers use — so this never forces the page dynamic and the
 * public DE build is byte-identical (the launcher, already `ssr:false`, simply
 * never mounts without the cookie). Glue imposes no DE gate, so the widget talks
 * to the real KB: this is a live preview of the assistant, not a mock.
 */
export function EllaDePreviewLauncher(props: ChatLauncherProps) {
  const [active, setActive] = useState(false)
  useEffect(() => {
    setActive(hasEllaDePreviewActive())
  }, [])

  if (!active) return null
  return <ChatLauncherLazy {...props} />
}
